import classnames from 'classnames';
import React from 'react';

import { SIZES } from '../../core/constants';
import styles from './spinner.scss';

export interface Props {
  className?: string;
  color: 'white' | 'normal';
  size: SIZES;
}

export class Spinner extends React.PureComponent<Props> {
  public static defaultProps = {
    color: 'normal',
    size: SIZES.MEDIUM
  };

  public render(): JSX.Element {
    const { className, color, size } = this.props;

    return <div data-testid="spinner" className={classnames(styles.spinner, styles[size], styles[color], className)} />;
  }
}
